import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";

import { AppDispatch, RootState, AppStore } from "./store";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = useStore.withTypes<AppStore>();
